import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDzAg3jzSiW3araf0VMHBUg1pCJv6Xq0vw",
  authDomain: "algorithms-expert.firebaseapp.com",
  projectId: "algorithms-expert",
  storageBucket: "algorithms-expert.appspot.com",
  messagingSenderId: "623218486210",
  appId: "1:623218486210:web:b5a1c4e9efa7451a7f445b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app